export interface ISourcePrinterSpecifiable {
  printSourceTo(source: string, printerName: string, copies: number, launchRequestKey: string): void;
}

export function instanceOfISourcePrinterSpecifiable(instance: any): instance is ISourcePrinterSpecifiable {
  return instance && (instance.printSourceTo !== undefined);
}
